import dayjs from 'dayjs';

export const isoFormat = "YYYY-MM-DDTHH:mm:ss";

export function formatDateFullTime(language, dateTime) {
    let formatSv = "YYYY-MM-DD HH:mm:ss";
    let formatEn = "MM/DD/YYYY hh:mm:ss A";

     let formattedDate = dateTime ? dayjs(dateTime).format(language === 'sv' ? formatSv : formatEn) : "";
    
    return formattedDate;
}

export function formatDateTime(language, dateTime) {
    let formatSv = "YYYY-MM-DD HH:mm";
    let formatEn = "MM/DD/YYYY hh:mm A";

     let formattedDate = dateTime ? dayjs(dateTime).format(language === 'sv' ? formatSv : formatEn) : "";
    
    return formattedDate;
}

export function formatDate(language, dateTime) {
    let formatSv = "YYYY-MM-DD";
    let formatEn = "MM/DD/YYYY";
        let formattedDate = dateTime ? dayjs(dateTime).format(language === 'sv' ? formatSv : formatEn) : "";
        return formattedDate;
}

export function formatTime(language, dateTime) {
    let formatSv = "HH:mm";
    let formatEn = "hh:mm A";
        let formattedDate = dateTime ? dayjs(dateTime).format(language === 'sv' ? formatSv : formatEn) : "";
        return formattedDate;
}

export function formatFullTime(language, dateTime) {
    let formatSv = "HH:mm:ss";
    let formatEn = "hh:mm:ss A";
        let formattedDate = dateTime ? dayjs(dateTime).format(language === 'sv' ? formatSv : formatEn) : "";
        return formattedDate;
}

export function formatDateTimeISO(dateTime) {
    let formattedDate = dateTime ? dayjs(dateTime).format(isoFormat) : "";
    return formattedDate;
}
